/*
 * This file is edited by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, { Fragment, PureComponent } from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";

import setAuthToken from "../utils/setAuthToken";

import DashboardLayout from "../containers/Layout/Dashboard";
import LoginPage from "../pages/Login";
import ForgotPasswordPage from "../pages/ForgotPassword";
import RecoverPassword from "../pages/RecoverPassword";
import SignUpPage from "../pages/SignUp";
import SignUpSuccessPage from "../pages/SignupSuccess";
import NotificationPage from "../pages/Notifications";
import ConsultHistoryPage from "../pages/ConsultHistory";
import ConsultHistoryViewPage from "../pages/ConsultHistory/View";
import TicketsPage from "../pages/Tickets";
import TicketsEditPage from "../pages/Tickets/Edit";
import OpenAppointmentsPage from "../pages/OpenAppointments";
import ViewAppointmentPage from "../pages/OpenAppointments/View";
import MyAppointmentsPage from "../pages/MyAppointments";
import ProfilePage from "../pages/Profile";
import EditProfilePage from "../pages/Profile/Edit";
import BankDetailsPage from "../pages/BankDetails";
import AddBankAccountPage from "../pages/BankDetails/Add";
import EditBankDetailsPage from "../pages/BankDetails/Edit";
import ConsultCostPage from "../pages/ConsultCost";
import PaymentSummaryPage from "../pages/PaymentSummary";
import TaxInvoicesPage from "../pages/TaxInvoices";
import HelpPage from "../pages/Help";
import LegalPage from "../pages/Legal";
import ChangePasswordPage from "../pages/ChangePassword";

import appRoutes from "./appRoutes";
import CallRequestReceive from "../pages/Call/receiveRequest";
import PatientCallAccepted from "../pages/Call/callRequestAccepted";

import PatientsQueuePage from "../pages/PatientsQueue";

import ForumListPage from "../pages/Forum/forumList";
import ForumPostDetails from "../pages/Forum/forumPostDetails";
import CreateForumPostPage from "../pages/Forum/createPost";

// Instant Switch Pages
import AssessmentListPage from "../pages/InstantSwitch/AssessmentList/assessmentListPage";
import AssessmentViewPage from "../pages/InstantSwitch/AssessmentViewPage/assessmentViewPage";
import ViewCompletedAssessmentPage from "../pages/InstantSwitch/AssessmentViewPage/ViewCompletedAssessment";

// Instant Hush Pages
import InstantHushAssessmentListPage from "../pages/InstantHush/AssessmentList/assessmentListPage";
import InstantHushAcceptAssessmentPage from "../pages/InstantHush/acceptAssessmentPage";
import InstantHushViewCompletedAssessmentPage from "../pages/InstantHush/viewCompletedAssessmentPage";

import socket from "../utils/socket";
import AssessmentListMCPage from "../pages/InstantSwitch/AssessmentList/assessmentListMCPage";
import ShiftsPage from "../pages/InstantExtra/ShiftsPage";
import TagTopicsCPDPage from "../pages/TagTopicsCPD/TagTopicsCPD";

// we will use this components for the restricted routes which can be accessed after login only
const RestrictedRoute = props => (
  <Fragment>
    {props.isLoggedIn === true ? (
      <Route path={props.path} component={props.component} />
    ) : (
      <Redirect to="/login" from={props.path} />
    )}
  </Fragment>
);


// We will use this component for public routes which cannot be access after login
const PublicRoute = props => (
  <Fragment>
    {props.isLoggedIn === false ? (
      <Route path={props.path} component={props.component} />
    ) : (
      <Redirect to={appRoutes.patientsQueue} from={props.path} />
    )}
  </Fragment>
);

class AppRoutes extends PureComponent {
  render() {
    const auth = this.props.auth;
    const constants = this.props.commonReducers.constants;

    //set the token even after page refreshes
    setAuthToken(auth.accessToken ? auth.accessToken : false);

    if (!auth.isLoggedIn || !auth.user) {
      try {
        console.log("Disconnect socket from index as user is not logged in");
        socket.disconnect();
      } catch (e) {
        console.log("Error during Doctor try to disconnect from index route: ", e);
      }
    }

    return (
      <div>
        <Router>
          <Switch>
            <Redirect exact from="/" to="/login" />
            <Redirect exact from="/dashboard" to={appRoutes.patientsQueue} />
            <PublicRoute
              path="/login"
              component={LoginPage}
              isLoggedIn={auth.isLoggedIn}
            />
            <PublicRoute
              path={appRoutes.forgotPassword}
              component={ForgotPasswordPage}
              isLoggedIn={auth.isLoggedIn}
            />
            <PublicRoute
              path={appRoutes.signUp}
              exact
              component={SignUpPage}
              isLoggedIn={auth.isLoggedIn}
            />
            <PublicRoute
              path={appRoutes.signUpSuccess}
              component={SignUpSuccessPage}
              isLoggedIn={auth.isLoggedIn}
            />
            <PublicRoute
              path={appRoutes.recover}
              component={RecoverPassword}
              isLoggedIn={auth.isLoggedIn}
            />
            <Route path="/">
              <Switch>
                <DashboardLayout>
                  {/*<RestrictedRoute
                    path={appRoutes.dashboard}
                    component={DashboardPage}
                    isLoggedIn={auth.isLoggedIn}
                  /> */}
                  <RestrictedRoute
                    path={appRoutes.patientsQueue}
                    component={PatientsQueuePage}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.notifications}
                    component={NotificationPage}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.consultHistory}
                    component={ConsultHistoryPage}
                    exact
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.consultHistoryView}
                    exact
                    component={ConsultHistoryViewPage}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.tickets}
                    component={TicketsPage}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.editTicket}
                    component={TicketsEditPage}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.openAppointments}
                    component={OpenAppointmentsPage}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.viewAppointment}
                    component={ViewAppointmentPage}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.myAppointments}
                    component={MyAppointmentsPage}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.profile}
                    component={ProfilePage}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.editProfile}
                    component={EditProfilePage}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.bankDetails}
                    component={BankDetailsPage}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.addBankDetails}
                    component={AddBankAccountPage}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.editBankDetails}
                    component={EditBankDetailsPage}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.consultCost}
                    component={ConsultCostPage}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.paymentSummary}
                    component={PaymentSummaryPage}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.taxInvoice}
                    component={TaxInvoicesPage}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.help}
                    component={HelpPage}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.legal}
                    component={props => (<LegalPage constants={constants}/>)}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.changePassword}
                    component={ChangePasswordPage}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.callRequestReceive}
                    component={CallRequestReceive}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.callRequestAccepted}
                    component={PatientCallAccepted}
                    isLoggedIn={auth.isLoggedIn}
                  />

                  <RestrictedRoute
                    path={appRoutes.viewForum}
                    component={ForumListPage}
                    isLoggedIn={auth.isLoggedIn}
                  />

                  <RestrictedRoute
                    path={appRoutes.createForumPost}
                    component={CreateForumPostPage}
                    isLoggedIn={auth.isLoggedIn}
                  />

                  <RestrictedRoute
                    path={appRoutes.forumPostDetails + "/:id"}
                    component={ForumPostDetails}
                    isLoggedIn={auth.isLoggedIn}
                  />
                  <RestrictedRoute
                    path={appRoutes.instantExtraDoctorSchedule}
                    component={ShiftsPage}
                    isLoggedIn={auth.isLoggedIn}
                  />

                  <RestrictedRoute
                    path={appRoutes.instantSwitch}
                    component={AssessmentListPage}
                    isLoggedIn={auth.isLoggedIn}
                    isAccessToInstantSwitch={auth.isAccessToInstantSwitch}
                  />

                  <RestrictedRoute
                    path={appRoutes.instantLeaf}
                    component={AssessmentListMCPage}
                    isLoggedIn={auth.isLoggedIn}
                    isAccessToInstantSwitchMc={auth.isInstantSwitchMCAccessGranted}
                  />

                  <RestrictedRoute
                    path={appRoutes.instantSwitchAcceptAssessment + '/:id'}
                    component={AssessmentViewPage}
                    isLoggedIn={auth.isLoggedIn}
                    isAccessToInstantSwitch={auth.isAccessToInstantSwitch}
                  />

                  <RestrictedRoute
                    path={appRoutes.instantSwitchViewCompletedAssessment + '/:id'}
                    component={ViewCompletedAssessmentPage}
                    isLoggedIn={auth.isLoggedIn}
                    isAccessToInstantSwitch={auth.isAccessToInstantSwitch}
                  />

                  <RestrictedRoute
                    path={appRoutes.instantHush}
                    component={InstantHushAssessmentListPage}
                    isLoggedIn={auth.isLoggedIn}
                    isAccessToInstantSwitch={auth.isAccessToInstantHush}
                  />

                  <RestrictedRoute
                    path={appRoutes.instantHushAcceptAssessment}
                    component={InstantHushAcceptAssessmentPage}
                    isLoggedIn={auth.isLoggedIn}
                    isAccessToInstantSwitch={auth.isAccessToInstantHush}
                  />

                  <RestrictedRoute
                    path={appRoutes.instantHushViewCompletedAssessment + '/:id'}
                    component={InstantHushViewCompletedAssessmentPage}
                    isLoggedIn={auth.isLoggedIn}
                    isAccessToInstantSwitch={auth.isAccessToInstantHush}
                  />

                  <RestrictedRoute
                    path={appRoutes.tagTopicsCPD}
                    component={TagTopicsCPDPage}
                    isLoggedIn={auth.isLoggedIn}
                  />

                </DashboardLayout>
              </Switch>
            </Route>{" "}
            {/* <Route component={Error404} path="/404" /> */}
            <Redirect from="*" to="/404" />
          </Switch>
        </Router>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  commonReducers: state.commonReducers
});

export default connect(mapStateToProps, null)(AppRoutes);
